import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, withWidth, Tabs, Tab, Tooltip } from '@material-ui/core';
import { isWidthDown } from '@material-ui/core/withWidth';
import { fade } from '@material-ui/core/styles';
import { FHEContainerScroll, FHEDivider } from 'data/components';

function TabPanel(props) {
    const { children, value, index, classPanel, title, icon, ...other } = props;

    return (
        <div
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            className={classPanel}
            {...other}
        >
            <FHEDivider title={title} IconComponent={icon} />
            <FHEContainerScroll>{children}</FHEContainerScroll>
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node.isRequired,
    classPanel: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};
class SubMenuVertical extends PureComponent {
    static propTypes = {
        childRef: PropTypes.func.isRequired,
        theme: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        width: PropTypes.string.isRequired,
        tabList: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        let currentTab = 0;
        Object.keys(props.tabList).map((tabName, tabKey) => {
            const tab = props.tabList[tabName];
            if (tab.firstTab) currentTab = tabKey;
        });
        this.state = {
            currentTab: currentTab,
            isTabHovering: null
        };
    }

    componentDidMount() {
        const { childRef } = this.props;
        childRef(this);
    }
    componentWillUnmount() {
        const { childRef } = this.props;
        childRef(undefined);
    }

    static getDerivedStateFromProps(props, state) {
        const { currentTab } = state;
        const { tabList } = props;
        const hash = window.location.hash ? window.location.hash.substring(1) : '';
        const newTab = Object.keys(tabList).indexOf(hash);
        if (newTab !== -1 && newTab !== currentTab) {
            return {
                currentTab: newTab
            };
        }
        return null;
    }

    handleChange = (event, newTab) => {
        const { tabList, location } = this.props;

        let newHash = '';
        Object.keys(tabList).map((tabName, tabKey) => {
            if (tabKey === newTab) newHash = `${tabName}`;
        });
        window.history.replaceState('object or string', 'Title', `${location.pathname}#${newHash}`);
        this.setState({ currentTab: newTab });
    };

    toggleHoverState = tabKey => {
        const { isTabHovering } = this.state;
        this.setState({ isTabHovering: tabKey === isTabHovering ? null : tabKey });
    };

    renderTabs = () => {
        const { currentTab, isTabHovering } = this.state;
        const { tabList, theme, classes, width } = this.props;
        const iconSize = isWidthDown('xs', width) ? 15 : 20;
        let tabs = { menus: [], panels: [] };
        Object.keys(tabList).map((tabName, tabKey) => {
            const tab = tabList[tabName];
            tabs.menus.push(
                <Tooltip key={tabKey} title={tab.label} placement="right">
                    <Tab
                        id={`vertical-tab-${tabKey}`}
                        aria-controls={`vertical-tabpanel-${tabKey}`}
                        value={tabKey}
                        icon={
                            <tab.Icon
                                color={
                                    currentTab === tabKey || isTabHovering === tabKey ? theme.palette.primary.main : theme.palette.background.paper
                                }
                                size={iconSize}
                            />
                        }
                        onMouseEnter={this.toggleHoverState.bind(this, tabKey)}
                        onMouseLeave={this.toggleHoverState.bind(this, tabKey)}
                        classes={{ root: classes.root, selected: classes.selected, wrapper: classes.tabWrapper }}
                    />
                </Tooltip>
            );
            tabs.panels.push(
                <TabPanel value={currentTab} index={tabKey} key={tabKey} classPanel={classes.panel} title={tab.label} icon={tab.Icon}>
                    <tab.View isActive={tabKey === currentTab} />
                </TabPanel>
            );
        });
        return tabs;
    };

    render() {
        const { currentTab } = this.state;
        const { classes } = this.props;
        const tabs = this.renderTabs();
        return (
            <div className={classes.menuVertical}>
                <Tabs orientation="vertical" value={currentTab} onChange={this.handleChange} variant="scrollable" className={classes.tabs}>
                    {tabs.menus}
                </Tabs>
                {tabs.panels}
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}
const aWidth = {
    xs: 30,
    all: 50
};
const borderRadius = {
    xs: 10,
    all: 15
};

const styles = theme => ({
    menuVertical: {
        flexGrow: 1,
        minHeight: 255,
        display: 'flex'
    },
    tabs: {
        position: 'fixed',
        left: 10,
        top: 'calc(50% - 312px/2)',
        width: aWidth['all'],
        [theme.breakpoints.down('md')]: {
            left: 15
        },
        [theme.breakpoints.down('xs')]: {
            top: 'calc(50% - 192px/2)',
            left: 6,
            width: aWidth['xs']
        }
    },
    root: {
        opacity: 1,
        overflow: 'initial',
        padding: 0,
        borderTopLeftRadius: borderRadius['all'],
        borderBottomLeftRadius: borderRadius['all'],
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.paper,
        minWidth: aWidth['all'],
        minHeight: aWidth['all'],
        margin: '1px 0',
        transition: '0.2s',
        '&:before': {
            transition: '0.2s'
        },
        '& + $root:after': {
            color: theme.palette.background.paper
        },
        '& + $selected:before': {
            opacity: 0
        },
        '&:hover': {
            '&:not(selected)': {
                backgroundColor: fade(theme.palette.background.paper, 0.9),
                color: theme.palette.primary.main
            },
            '&::before': {
                opacity: 0
            },
            '& + $root:before': {
                opacity: 0
            }
        },
        [theme.breakpoints.down('xs')]: {
            minWidth: aWidth['xs'],
            minHeight: aWidth['xs'],
            borderTopLeftRadius: borderRadius['xs'],
            borderBottomLeftRadius: borderRadius['xs']
        }
    },
    selected: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
        '& + $root': {
            zIndex: 1
        },
        '& + $root:before': {
            opacity: 0
        }
    },
    tabWrapper: {
        zIndex: 2,
        marginLeft: borderRadius['all'] / 2,
        textTransform: 'initial',
        [theme.breakpoints.down('xs')]: {
            marginLeft: borderRadius['xs'] / 2
        }
    },
    panel: {
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
});

export default withRouter(connect(mapStateToProps)(withWidth()(withStyles(styles, { withTheme: true })(SubMenuVertical))));



// WEBPACK FOOTER //
// ./data/components/SubMenuVertical.js